import { FC } from "react";
import { useGoalRewardContext } from "./context";
import { Text } from '@constructor/components';

const GoalRewardDescription: FC = (props) => {
    const reward = useGoalRewardContext();
    if (!reward?.description) {
        return null;
    }

    return (
        <Text text={reward.description} {...props} />
    )
}

export default GoalRewardDescription;